<!-- 
ShareLinkUse.vue
功能：分享連結使用
作者：i9400538 陳博承
完成：2022-01-18
-->
<template>
  <main>
    <div>
      <table id="share-link-table">
        <tr>
          <td>
            <span class="title-use">{{title}}</span>
          </td>
          <td>
            <input
              type="text"
              style="position:absolute;left:-10000px;top:-10000px"
              id="copyTextShareLinkUse"
            />
            <button type="button" class="btn btn-default btn-sm" @click="copy(mmlUrl)">複製連結</button>
          </td>
          <td>
            <i class="icon-facebook share-link-click" @click="encodeLink('fb', fbMetaUrl)"></i>
          </td>
          <td>
            <i class="icon-line share-link-click" @click="encodeLink('line', mmlUrl)"></i>
          </td>
        </tr>
      </table>
    </div>
  </main>
</template>
<script>
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
export default {
  name: "ShareLinkUse",
  mixins: [commonMixin],
  props: {
    mmlUrl: {
      type: String,
      default: ""
    },
    fbMetaUrl: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === "box";
    }
  },
  metaInfo() {
    return {
      meta: [
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.fbMetaUrl },
        {
          property: "og:description",
          content: this.content
        }
      ]
    };
  },
  methods: {
    //判斷是line還是FB
    encodeLink(type, link) {
      if (this.isBox) {
        this.boxCathayShareLink(link);
      } else {
        let str = encodeURI(link);
        let url =
          type === "fb"
            ? `http://www.facebook.com/share.php?u=${str}`
            : `http://line.naver.jp/R/msg/text/?${str}`;
        window.open(url);
      }
    },
    //複製連結
    copy(url) {
      if (this.isBox) {
        this.boxCathayShareLink(url);
      } else {
        let copyText = document.getElementById("copyTextShareLinkUse");
        copyText.value = url;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        if (document.execCommand("cut")) {
          this.$toast.info({ title: "連結已複製" });
        } else {
          console.error("複製失敗");
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.title-use {
  font-size: 20px;
  font-weight: 600;
}
.share-link-click {
  cursor: pointer;
}
.font-size-20px {
  font-size: 20px;
}
</style>